import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "6",
      cy: "6",
      r: "5",
      stroke: "#161616",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11 11L14 14",
      stroke: "#161616",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }